import React from 'react';
import * as MetaConnectionsTypes from './metaConnections.types';
import { metaError } from 'utils/errorCodes';
import { notificationErr } from 'views/components/UI/notification';
import * as msg from 'views/components/UI/message';
import * as api from 'api/endpoints/meta/meta.api';
import * as metaResponseInterface from 'api/endpoints/meta/meta.response.interface';
import * as metaInterface from 'interfaces/meta.interface';
import { ITranslate } from 'interfaces/general.interface';
import { TMetaConnectionsDispatchReducer } from './metaConnections.reducer';

export async function getConnectionsAction({
  dispatch,
  body,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TMetaConnectionsDispatchReducer>;
  body: metaResponseInterface.TgetConnectorsAPIBodyProps;
  token: string;
  translate: ITranslate;
}) {
  dispatch({ type: MetaConnectionsTypes.SET_IS_LOADING_CONNECTIONS, payload: true });
  try {
    const getConnectionsFetch = await api.getConnectionsAPI({ body, token });
    if (getConnectionsFetch.response.status === 200) {
      if (getConnectionsFetch.data.sftp?.length > 0) {
        const connections: Array<metaInterface.TSftpUserItem> =
          getConnectionsFetch.data.sftp.map((connection) => ({
            ...connection,
            type: metaInterface.connectorTypes.sftp as metaInterface.TConnectorTypes,
          }));

        dispatch({
          type: MetaConnectionsTypes.SET_SFTP_CONNECTIONS,
          payload: connections,
        });
      }
      if (getConnectionsFetch.data.shopify?.length > 0) {
        const connections: Array<metaInterface.TShopifyConnectionItem> =
          getConnectionsFetch.data.shopify.map((connection, index) => ({
            ...connection,
            type: metaInterface.connectorTypes.shopify as metaInterface.TConnectorTypes,
          }));

        dispatch({
          type: MetaConnectionsTypes.SET_SHOPIFY_CONNECTIONS,
          payload: connections,
        });
      }
      return true;
    }
    return false;
  } catch (err) {
    console.log(err);
    msg.messageError(translate('action_meta_get-connections_error'));
    notificationErr(metaError.get_connections_001, translate);
    return false;
  } finally {
    dispatch({ type: MetaConnectionsTypes.SET_IS_LOADING_CONNECTIONS, payload: false });
  }
}
